export default {
  title: "Hunter",
  content: [
    "New ability: Aspect of the Viper: The hunter takes on the aspect of the viper, causing ranged and melee attacks to regenerate mana but reducing your total damage done by 50%. In addition, you gain 4% of maximum mana every 3 sec.",
    "Trueshot Aura is now a baseline ability.",
    "Mongoose Bite now deals percent weapon damage and scales with attack power.",
    "Mend pet is now instant cast and has 40 yard range. It is still a heal over time effect.",
    "Aspect of the Beast reworked: now increases the melee attack power of the hunter and the hunter's pet.",
    "Aspect of the Wild now also makes affected targets untrackable.",
    "All pets will now receive a percentage of their master's stats and their spell damage and attack power is increased by a percentage of their master's attack power.",
    "Number of stable slots increased.",
  ],
};
